import Traslates from './Traslates';
export default Traslates;